import { Student } from '@buf/studyo_studyo-today-schools.bufbuild_es/studyo/today/schools/v1/resources/student_pb';
import { WorkloadStatus } from '@buf/studyo_studyo-today-schools.bufbuild_es/studyo/today/schools/v1/resources/workload_status_pb';
import { Box, ListItem, ListItemText, Stack } from '@mui/material';
import { SxProps } from '@mui/system';
import { observer } from 'mobx-react-lite';
import LocalizedStrings from 'strings';
import { Banner } from '../../utils';

export interface PublishedWorkEditWorkloadImpactIndicatorPopoverSectionProps {
  sx?: SxProps;
  className?: string;
  status: WorkloadStatus.ABOVE_THRESHOLD | WorkloadStatus.AT_THRESHOLD;
  students: Student[];
}

export const PublishedWorkEditWorkloadImpactIndicatorPopoverSection = observer(
  ({ sx = [], students, status, className }: PublishedWorkEditWorkloadImpactIndicatorPopoverSectionProps) => {
    const strings = LocalizedStrings.publishedWork.edit;

    const title =
      status === WorkloadStatus.ABOVE_THRESHOLD
        ? strings.workloadImpactDetailsPopoverAboveThreshold()
        : strings.workloadImpactDetailsPopoverAtThreshold();
    const severity = status === WorkloadStatus.ABOVE_THRESHOLD ? 'error' : 'warning';

    return (
      <Stack spacing={1} sx={sx} className={className}>
        <Box sx={{ px: 1 }}>
          <Banner severity={severity}>{title}</Banner>
        </Box>
        <Stack>
          {students.map((student) => (
            <ListItem key={student.accountId} dense>
              <ListItemText primary={student.fullName} slotProps={{ primary: { variant: 'body2' } }} />
            </ListItem>
          ))}
        </Stack>
      </Stack>
    );
  }
);
